import styled, { css } from "styled-components";

export const InputSearchWithDropdownDropdownContainer = styled.div`
  background-color: ${({ theme }) => theme?.console?.backgroundColor};
  border-radius: 4px;

  opacity: 0;
  width: 100%;

  position: absolute;
  z-index: 999;

  &,
  .content {
    max-height: 0px;
    overflow-y: auto;
  }

  .content {
    border-top: 1px solid ${({ theme }) => theme?.console?.inputBorderColor};
    padding-bottom: 1rem;

    :empty {
      padding: 0 !important;
      margin: 0;
    }
  }

  border: 1px solid ${({ theme }) => theme?.console?.inputBorderColor};
  border-top: none;

  transition: 0.3s ease-in-out;

  > .search-input-container {
    position: relative;

    margin: 1rem;

    input {
      border-radius: 4px;
      background-color: ${({ theme }) => theme?.console?.backgroundColor};
      color: ${({ theme }) => theme?.console?.inputColor};

      height: 48px;

      border: 1px solid ${({ theme }) => theme?.console?.inputBorderColor};

      width: 100%;

      padding-left: 2rem;
    }

    button {
      width: 32px;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      background: transparent;

      border: none;

      position: absolute;

      :disabled,
      svg {
        pointer-events: none;
      }
    }
  }
`;

interface InputSearchWithDropdownContainerProps {
  isDropdownOpen?: boolean;
}

export const InputSearchWithDropdownContainer = styled.div<InputSearchWithDropdownContainerProps>`
  position: relative;

  > button#toggle-dropdown-button {
    padding: 0rem 1rem;

    border-radius: 4px;
    background-color: ${({ theme }) => theme?.console?.backgroundColor};

    width: 100%;

    transition: 0.3s all;

    height: 48px;

    border: 1px solid ${({ theme }) => theme?.console?.inputBorderColor};

    display: grid;
    grid-template-columns: 1fr auto;
    justify-content: space-between;
    align-items: center;

    > span {
      grid-column: 1;
      text-align: start;
    }

    > svg {
      grid-column: 2;
      color: #c8c8c9;
    }

    :has(.value-area) {
      > svg {
        grid-row: 1 / 3;
      }
    }

    .value-area {
      grid-row: 2;
    }

    > span {
      color: #6c6c71;
      font: 600 0.625rem/0.8125rem "Inter";

      transition: 0.3s all;

      .required-flag {
        color: #ec3434;
        font: 600 0.625rem/0.01563rem "Inter";
        margin-left: 0.2rem;
      }
    }

    :hover:not(:disabled) {
      cursor: pointer;
    }

    :disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }

    svg {
      transition: 0.3s all;
    }

    ${({ isDropdownOpen }) =>
      isDropdownOpen &&
      css`
        svg {
          transform: rotate(180deg);
        }
      `}
  }

  ${({ isDropdownOpen }) =>
    isDropdownOpen
      ? css`
          ${InputSearchWithDropdownDropdownContainer} {
            max-height: 400px;

            opacity: 1;
            .content {
              max-height: 290px;

              &::-webkit-scrollbar {
                width: 4px;
                display: block;
              }

              &::-webkit-scrollbar-track {
                width: 4px;
                display: block;
              }

              &::-webkit-scrollbar-thumb {
                width: 4px;
                display: block;
              }
            }
          }
        `
      : css`
          /* ${InputSearchWithDropdownDropdownContainer} {
            border: none;
          } */
        `}
`;
